package com.huanshankeji.compose.material.icons

actual class Icon(val name: String)
